import request from '@/utils/request'

const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST

export function getCustomerListApi(params) {
  return request({
    url: jsApiHost + '/god/customer/list',
    method: 'get',
    params
  })
}

export function updateCustomerApi(data) {
  return request({
    url: jsApiHost + '/god/customer/post',
    method: 'post',
    data
  })
}
